<script setup lang="ts">
import { computed, useAttrs } from 'vue';
import type { StyleValue } from 'vue';
import { useRoute } from '#app/composables/router';

interface Props {
  mainClass?: StyleValue;
  // FIXME: トンマナを揃えるため、レシピの場合とニュースの場合で各パーツの色を変えたりしてる。
  // 将来的に統一できればだいぶコード減りそう
  isRecipeDesign?: boolean;
}

const props = defineProps<Props>();

const route = useRoute();
const layoutCustomProps = useAttrs();

const contentBg = computed(() => {
  return route.meta.contentBg as string | undefined;
});

// NOTE: pagesファイル側の `definePageMeta` で `contentBg` が指定されていた場合は、その値をコンテンツの背景色として設定する
// 動的に挿入されるため、tailwindのclassで指定した場合はpurgecssで削除されてしまうので、あえて直接style属性で指定している
const wrapperStyle = computed(() => {
  if (!contentBg.value) {
    return undefined;
  }

  return {
    backgroundColor: contentBg.value,
  };
});

const showSideBar = computed(() => {
  return !route.meta.hideSideBar && layoutCustomProps['hide-side-bar'] !== true;
});

const wrapperClass = computed(() => {
  if (props.isRecipeDesign) {
    return ['border-t border-gray-300 md:pt-5 bg-cream-200 pb-16'];
  }

  return ['md:pt-3 pt-2 mb-16'];
});

const breadcrumbsClass = computed(() => {
  if (props.isRecipeDesign) {
    return ['max-md:hidden'];
  }

  return [];
});

const mainClass = computed(() => {
  if (props.isRecipeDesign) {
    return [''];
  }

  return ['bg-white'];
});
</script>

<template>
  <div>
    <OrganismsDietPlusPcHeader class="mb-2" />
    <OrganismsDietPlusSpHeader />

    <div
      data-testid="content-wrapper"
      :style="wrapperStyle"
      :class="wrapperClass"
    >
      <div class="md:flex max-w-content-width mx-auto justify-between">
        <div class="grow overflow-hidden">
          <AtomsBreadcrumbs :class="breadcrumbsClass" />

          <main :class="mainClass">
            <slot />
          </main>
        </div>

        <OrganismsDietPlusSideBar
          v-if="showSideBar"
          :is-recipe-design="isRecipeDesign"
          class="hidden md:block md:w-[300px] ml-6 shrink-0"
        />
      </div>
    </div>

    <AtomsRecipeDisclaimer v-if="isRecipeDesign" />

    <AtomsDietPlusFooter />
    <OrganismsLoglyLift />
  </div>
</template>
